export const FETCH_UNVALIDATED_PERIODS_REQUEST = 'FETCH_UNVALIDATED_PERIODS_REQUEST';
export const FETCH_UNVALIDATED_PERIODS_SUCCESS = 'FETCH_UNVALIDATED_PERIODS_SUCCESS';
export const FETCH_UNVALIDATED_PERIODS_FAILURE = 'FETCH_UNVALIDATED_PERIODS_FAILURE';
export const RESET_UNVALIDATED_PERIODS_FAILURE = 'RESET_UNVALIDATED_PERIODS_FAILURE';

export const fetchUnvalidatedPeriodsRequest = courseGuid => ({
  type: FETCH_UNVALIDATED_PERIODS_REQUEST,
  courseGuid,
});

export const fetchUnvalidatedPeriodsSuccess = payload => ({
  type: FETCH_UNVALIDATED_PERIODS_SUCCESS,
  payload,
});

// TODO: Remove? Not being used
export const fetchUnvalidatedPeriodsFailure = error => ({
  type: FETCH_UNVALIDATED_PERIODS_FAILURE,
  payload: error,
});

export const resetUnvalidatedPeriodsFailure = () => ({ type: RESET_UNVALIDATED_PERIODS_FAILURE });
